import { useState } from "preact/hooks";
import {
  messages,
  escalationView,
  escalationSent,
  panelOpen,
  customerName,
  customerEmail,
  prefilledMail,
} from "../store";
import { handleEscalate } from "./handlers";
import { ChatHeader } from "./ChatHeader";
import { BACK, CHECK } from "./icons";

export function EscalationForm() {
  // ALL hooks must be at the top, before any early returns.
  // Per memory `hooks-rules-pattern.md`: ALDRI hooks etter early returns.
  const lastUserMsg =
    [...messages.value].reverse().find((m) => m.role === "user")?.content || "";
  // Hvis Iskra har foreslått et mail-utkast og kunden klikket "Send mail",
  // pre-fyll med utkastet. Ellers pre-fyll med siste user-melding (eksisterende).
  const initialMsg = prefilledMail.value || lastUserMsg;
  const [name, setName] = useState(customerName.value || "");
  const [email, setEmail] = useState(customerEmail.value || "");
  const [msg, setMsg] = useState(initialMsg);
  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  // Early return AFTER hooks
  if (escalationSent.value) {
    let sentEmail = "e-posten din";
    try {
      sentEmail = sessionStorage.getItem("iskra-last-email") || "e-posten din";
    } catch {
      /* sessionStorage blocked */
    }
    return (
      <>
        <ChatHeader />
        <div class="ic-escalation" role="status">
          <div class="ic-done-icon">{CHECK}</div>
          <h3>Takk, vi har fått meldingen</h3>
          <p class="ic-lede">Vi svarer deg vanligvis innen 24 timer på {sentEmail}.</p>
          <button
            class="ic-submit"
            onClick={() => {
              panelOpen.value = false;
              escalationSent.value = false;
            }}
          >
            Lukk
          </button>
        </div>
      </>
    );
  }

  const submit = async (e: Event) => {
    e.preventDefault();
    if (!name || !email || !msg) return;
    setSubmitting(true);
    setErr(null);
    try {
      sessionStorage.setItem("iskra-last-email", email);
    } catch {
      /* sessionStorage blocked */
    }
    try {
      await handleEscalate({ name, email, message: msg });
      // Nullstill prefilled-mail-state etter vellykket submit.
      prefilledMail.value = null;
    } catch {
      setErr(
        "Meldingen kom ikke fram. Prøv igjen, eller skriv direkte til mattis@badstugutta.no"
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <ChatHeader />
      <div class="ic-escalation">
        <h3>Send oss en e-post</h3>
        <p class="ic-lede">
          Vi svarer innen 24 timer, og tar med samtalen så langt så du slipper å gjenta deg.
        </p>
        <form onSubmit={submit}>
          <label class="ic-field">
            <span class="ic-field-label">Navn</span>
            <input
              type="text"
              required
              autoComplete="name"
              value={name}
              onInput={(e) => setName((e.target as HTMLInputElement).value)}
            />
          </label>
          <label class="ic-field">
            <span class="ic-field-label">E-post</span>
            <input
              type="email"
              required
              inputMode="email"
              autoComplete="email"
              value={email}
              onInput={(e) => setEmail((e.target as HTMLInputElement).value)}
            />
          </label>
          <label class="ic-field">
            <span class="ic-field-label">Melding</span>
            <textarea
              required
              value={msg}
              onInput={(e) => setMsg((e.target as HTMLTextAreaElement).value)}
            />
          </label>
          {err && <p class="ic-err" role="alert">{err}</p>}
          <button class="ic-submit" disabled={submitting}>
            {submitting ? "Sender …" : "Send e-post"}
          </button>
          <button
            type="button"
            class="ic-back"
            onClick={() => {
              escalationView.value = false;
              prefilledMail.value = null;
            }}
          >
            {BACK} Tilbake til chatten
          </button>
        </form>
      </div>
    </>
  );
}
